var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 76,
    viewBox: "0 0 87 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0488 0C7.67327 0 0 6.70294 0 14.8932V61.1093C0 69.2993 7.6731 76 17.0488 76H69.954C79.3296 76 87 69.2994 87 61.1093V14.8932C87 6.70309 79.3296 0 69.954 0H17.0488ZM21.3368 12.5415C25.8321 12.5415 28.601 15.1195 28.6865 18.5082C28.6865 21.8221 25.8319 24.4726 21.2498 24.4726H21.1655C16.7557 24.4726 13.9055 21.8223 13.9055 18.5082C13.9055 15.1196 16.8419 12.5415 21.3367 12.5415H21.3368ZM60.0757 28.38C68.7211 28.38 75.202 33.3162 75.202 43.9239V63.7267H62.0633V45.2516C62.0633 40.609 60.1618 37.4416 55.407 37.4416C51.7772 37.4416 49.6136 39.5765 48.6637 41.6388C48.3166 42.3767 48.2313 43.4071 48.2313 44.4393V63.7267H35.0927C35.0927 63.7267 35.2651 32.4305 35.0927 29.1899H48.234V34.0807C49.98 31.7274 53.1031 28.3799 60.0757 28.3799V28.38ZM14.6804 29.1924H27.8191V63.7269H14.6804V29.1924V29.1924Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b5ce31f664ace236a5133d03ed22917a.svg";
export { ForwardRef as ReactComponent };